/**
 * FROM field dropdown options
 * Each option has a value, label, and optional email
 */
export const FROM_OPTIONS = [
  { value: "@noReplyEmail", label: "No Reply Email", email: "no-reply@drutas.com" },
  { value: "@workflowEmailSystem", label: "Workflow Email (System)", email: "workflow@drutas.com" },
  { value: "@creatorDrutasEmail", label: "Task Creator Email", email: null },
  { value: "@currentAssigneeDrutasEmail", label: "Current Assignee (Email)", email: null },
];

/**
 * TO field predefined system recipient options
 */
export const TO_SYSTEM_OPTIONS = [
  { id: "@creatorDrutasEmail", label: "Creator (Drutas Email)", type: "predefined" },
  { id: "@creatorSSOEmail", label: "Creator (SSO Email)", type: "predefined" },
  { id: "@currentAssigneeDrutasEmail", label: "Current Assignee (Drutas Email)", type: "predefined" },
  { id: "@currentAssigneeSSOEmail", label: "Current Assignee (SSO Email)", type: "predefined" },
];

export const VARIABLE_OPTIONS = [
  { id: "@creatorL1Manager", label: "Creator | Manager L1", type: "predefined" },
  { id: "@creatorL2Manager", label: "Creator | Manager L2", type: "predefined" },
];

/**
 * System recipient dropdown options for TO/CC: base list, or base + manager variables when enabled.
 *
 * @param {boolean} includeVariableOptions - When true, appends `VARIABLE_OPTIONS` after `TO_SYSTEM_OPTIONS`
 * @returns {Array<{ id: string, label: string, type: string }>}
 * @author Sejal
 */
export function getToSystemOptionsMerged(includeVariableOptions) {
  if (includeVariableOptions) {
    return [...TO_SYSTEM_OPTIONS, ...VARIABLE_OPTIONS];
  }
  return TO_SYSTEM_OPTIONS;
}
/**
 * Subject placeholder pill options
 */
export const SUBJECT_PLACEHOLDERS = [
  { id: "ticket-id", label: "Ref ID", value: " @refId " , placeholder: "ReferenceId" },
  { id: "ref-id", label: "Unique Id", value: " @uniqueId " , placeholder: "Unique Id" },
];

/**
 * Recipient type enum for consistent type checking
 */
export const RECIPIENT_TYPES = {
  SYSTEM: "system",
  MANUAL: "manual",
  USER: "user",
  WORKFLOW: "workflow",
};

/**
 * Maximum subject length
 */
export const SUBJECT_MAX_LENGTH = 100;

/**
 * Debounce delay for API search (ms)
 */
export const SEARCH_DEBOUNCE_DELAY = 300;
